import localforage from 'localforage'
import httpClient from './httpClient.util'

const documentsJsonStore = localforage.createInstance({
  driver: [localforage.INDEXEDDB, localforage.LOCALSTORAGE],
  name: 'ckd-cache',
})

const memoryCache = {}
const pendingRequests = {}

const isDocumentsJsonCacheEnabled = () => {
  return localStorage.getItem('isUseCache') !== 'false'
}

const clearDocumentsJsonMemoryCache = () => {
  Object.keys(memoryCache).forEach((cacheKey) => {
    delete memoryCache[cacheKey]
  })
}

if (typeof window !== 'undefined') {
  window.addEventListener('ckd-cache-clear', clearDocumentsJsonMemoryCache)
}

const normalizeDocumentsJsonUrl = (service) => {
  const serviceText = `${service || ''}`.trim()
  if (!serviceText) return ''
  if (serviceText.includes('/documents-json')) return serviceText

  const servicePath = serviceText.startsWith('/') ? serviceText : `/${serviceText}`
  return `${servicePath}/documents-json`
}

const getDocumentsJsonCacheKey = (service) => {
  return `documents-json:${normalizeDocumentsJsonUrl(service)}`
}

export const getDocumentsJson = async (service) => {
  const url = normalizeDocumentsJsonUrl(service)
  if (!url) return null

  if (!isDocumentsJsonCacheEnabled()) {
    return httpClient.get(url).then(({ data }) => data)
  }

  const cacheKey = getDocumentsJsonCacheKey(url)
  if (memoryCache[cacheKey]) return memoryCache[cacheKey]

  let storedData = null
  try {
    storedData = await documentsJsonStore.getItem(cacheKey)
  } catch {}

  if (storedData) {
    memoryCache[cacheKey] = storedData
    return storedData
  }

  if (pendingRequests[cacheKey]) return pendingRequests[cacheKey]

  pendingRequests[cacheKey] = httpClient
    .get(url)
    .then(({ data }) => {
      memoryCache[cacheKey] = data
      documentsJsonStore.setItem(cacheKey, data).catch(() => {})
      return data
    })
    .finally(() => {
      delete pendingRequests[cacheKey]
    })

  return pendingRequests[cacheKey]
}

export const removeDocumentsJsonCache = async (service) => {
  const cacheKey = getDocumentsJsonCacheKey(service)
  delete memoryCache[cacheKey]
  await documentsJsonStore.removeItem(cacheKey)
}
